import axios from 'Services/axiosInterceptor';
import { externalBaseUrl } from '../../../../configs/constants';

export const addAd = (payload) => {
  return axios.post(`${externalBaseUrl}/ads/create`, payload);
};

export const editAd = (payload) => {
  return axios.post(`${externalBaseUrl}/ads/update`, payload);
};

export const removeAd = (payload) => {
  return axios.post(`${externalBaseUrl}/ads/update-status`, payload);
};

export const bulkRemoveAds = (payload) => {
  return axios.post(`${externalBaseUrl}/ads/bulk-update-status`, payload);
};

export const updateAdOrder = (payload) => {
  return axios.post(`${externalBaseUrl}/ads/update-order`, payload);
};

export const addAdProduct = (payload) => {
  return axios.post(`${externalBaseUrl}/ads/ad-product-create`, payload);
};

export const editAdProduct = (payload) => {
  return axios.post(`${externalBaseUrl}/ads/ad-product-update`, payload);
};

export const removeAdProduct = (payload) => {
  return axios.post(`${externalBaseUrl}/ads/ad-product-update-status`, payload);
};

export const bulkRemoveAdProducts = (payload) => {
  return axios.post(`${externalBaseUrl}/ads/ad-product-bulk-update-status`, payload);
};

export const updateAdProductOrder = (payload) => {
  return axios.post(`${externalBaseUrl}/ads/ad-product-update-order`, payload);
};

export const addReward = (payload) => {
  return axios.post(`${externalBaseUrl}/rewards/create`, payload);
};

export const editReward = (payload) => {
  return axios.post(`${externalBaseUrl}/rewards/update`, payload);
};

export const removeReward = (payload) => {
  return axios.post(`${externalBaseUrl}/rewards/update-status`, payload);
};

export const bulkRemoveRewards = (payload) => {
  return axios.post(`${externalBaseUrl}/rewards/bulk-update-status`, payload);
};

export const updateRewardOrder = (payload) => {
  return axios.post(`${externalBaseUrl}/rewards/update-order`, payload);
};

